// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2AVUj","col":"styles_col__pMSQH"};